module.exports = "https://cdn-shared.mathletics.com/mathsaz/99/assets/images/10413e7457ff7651d19bfbcc61db22e0.svg";